// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"b26051a0","977":"fb55a997"}[chunkId] + ".chunk.js";
};